import React, { useState } from "react";
import { addSearchHistory } from "../../Services/api";

import hub_icon from "../../Assets/Images/icons/hublable.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const VendorProfileCard = ({ data }) => {

  const navigate = useNavigate();
  const userData = useSelector((state) => state.userAuth?.user);

  function openVendorProfile(vendorId) {
    let param = {
      search_vendor_id: vendorId,
    };
    if (userData.user_type != "Guest") {
      addSearchHistory(param).then((res) => {
        if (res.data?.status == "1") {
          navigate(`/vendor/${vendorId}`);
        }
      });
    } else {
      navigate(`/vendor/${vendorId}`);

    }
  }

  return (
    <div className="storeCards bg-white d-flex mb-3" role="button" onClick={() => openVendorProfile(data.vendor_id)} >
      <img src={data.vendor_logo} width="81" height="81" className="userImg rounded-3" alt="Vendor Logo" />

      <div style={{ width: "100%" }} className="ms-1">

        <div className="d-flex justify-content-between align-items-center">
          <div className="ff-poppins-semiBold  fs-13">
            {data.vendor_company_name}
          </div>
          {data.hub_status == 1 && (
            <img src={hub_icon} className="" height="16" width="51" />
          )}
        </div>

        <div className="d-flex mt-1">
          <div className="ff-poppins-regular secondary-text  fs-9 d-flex align-items-center">
            <div className="bullets me-2"></div>MID {data.vendor_id}
          </div>
          <div className="ff-poppins-regular secondary-text ms-1 fs-9 d-flex align-items-center ">
            <div className="bullets me-1"></div>
            {data.vendor_cat_name}
          </div>
        </div>

        <div className="ff-poppins-regular secondary-text fs-9 d-flex align-items-center mt-1">
          <div className="bullets me-2 vendor-address"></div>{" "}
          {data.vendor_address && data.vendor_address.length > 40
            ? data.vendor_address.slice(0, 40) + "..."
            : data.vendor_address}
        </div>

        <div className="d-flex justify-content-between secondary-text ms-3 mt-1">
          <p className="ff-poppins-regular fs-9 p-0 m-0">
            {data.distance ? data.distance : ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VendorProfileCard;
